module.exports = __webpack_public_path__ + "static/media/09_CORTINAO_SEM_BOJO_ESTAMPADO_05.56bda37d.jpg";